import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    sucursales: [],
  },
  mutations: {

    getSucursales(state, datos) {
      state.sucursales = datos;
    },

    destroySucursalesStore(state) {
      state.sucursales = [];
    },
    // insertSucursales(state, datos) {
    //   if (datos.MUNICIPIO!=null) {
    //     datos.NOMBRE = `IPS-${datos.MUNICIPIO}`;
    //     state.sucursales.push(datos);
    //   }
    // },

  },
  actions: {
    async getSucursales({
      commit,
    }) {
      try {
        const res = await api.getSucursales();
        // console.log(object);
        if (res.data.DATOS) {
          commit('getSucursales', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async insertSucursales({ commit }, suc) {
      try {
        const res = await api.insertSucursales(suc);
        if (res.data.INFO.cod === '200') {
          commit('insertSucursales', res.data.sucursal);
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },

    async destroySucursalesStore({
      commit,
    }) {
      commit('destroySucursalesStore');
    },

    async deleteSucursales({ commit }, suc) {
      try {
        const res = await api.deleteSucursales(suc);
        // commit('deleteSucursales', res.data.sucursal);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },

    async editSucursales({ }, suc) {
      try {
        const res = await api.editSucursales(suc);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },

  },
};
